<template>
  <footer class="myCanalFooter">
     <a href="https://www.canalplus.com/" target="_blank" rel="noopener noreferrer" class="myCanalFooter__logo">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="196"
          height="43"
          viewBox="0 0 196 43"
        >
          <g fill="none" fill-rule="nonzero">
            <path fill="#000" d="M58 43h138V0H58.003z" />
            <path
              fill="#FFF"
              d="M84.723 33.82c-.053.26-.161.47-.161.47s-.162.157-.377.21c-3.455 1.358-7.287.888-7.287.888-6.207-.68-10.147-4.342-11.443-9.1-1.889-7.114 1.836-12.187 2.753-13.286 2.213-2.563 5.613-4.34 8.96-4.759a19.51 19.51 0 0 1 8.743.784s1.457.471 2.538 1.151c.538.366.593.47.593.47s.054.052-.108.628l-1.026 5.127c-.053.209-.163.313-.163.313s-.053.052-.594-.261c-3.236-2.25-7.015-1.935-7.015-1.935-2.86.155-6.206 1.62-7.232 5.334-.917 3.242.053 6.015 2.051 7.636 1.35 1.151 3.508 1.727 5.721 1.622 2.428-.156 4.371-1.099 4.264-1.047 0 0 .107-.052.215-.052.487-.26.594-.209.594-.209s.108.104.055.419l-1.08 5.597zm55.809.94h-6.693l-.054-.052-8.905-15.378c-.054-.052-.108-.052-.108-.052s-.055 0-.055.106l-2.211 15.115c-.055.158-.055.21-.055.21s-.053.051-.163.051h-6.422c-.108 0-.162-.052-.162-.052s-.162-.157-.108-.26l3.508-24.427c.055-.158.109-.158.109-.158s.108-.103.215-.103h7.07a.242.242 0 0 1 .163.051s.054.052.107.158l8.043 13.703c.163.261.27.261.27.261s.108 0 .162-.313l2.05-13.651c0-.106.054-.158.054-.158s.055-.051.163-.051h6.746c.163 0 .163.051.163.051s.053.052.053.104l-3.617 24.636c-.053.157-.108.261-.108.261s-.053-.052-.215-.052m-35.783-9.937l-.055.052-5.181-.052c-.164 0-.217-.053-.217-.053s-.054-.052.055-.156l3.508-7.741.054-.053s.053 0 .053.053l1.781 7.793c.055.157 0 .157 0 .157h.002zm3.238-15.012c-.055-.103-.055-.157-.055-.157s-.108-.104-.27-.104H99.35s-.109.052-.163.158l-12.63 24.687c-.054.156-.054.26-.054.26s.055.105.27.053h7.287c.109 0 .216-.051.216-.051s.055-.054.108-.158l1.78-3.662c.11-.209.271-.313.271-.313s.108-.157.27-.157h8.96s.053.053.053.157l.972 3.923.054.261s.108.052.27.052h6.261c.054 0 .107-.052.107-.052s.055-.051.055-.157l-5.451-24.74zm46.524 15.64c-.109 0-.162-.105-.162-.21l2.698-7.636c.055-.104.108-.104.108 0l2.645 7.585c.054.104-.053.209-.163.209h-5.126v.052zm-.81-15.849c-.107 0-.216.104-.27.21l-9.824 24.791c-.052.105 0 .21.11.21h6.693c.107 0 .215-.105.269-.21l1.619-3.975c.053-.104.163-.21.27-.21h8.905c.108 0 .216.106.27.21l1.566 3.975c.053.105.161.21.27.21h6.8c.108 0 .163-.105.163-.21l-9.661-24.792c-.055-.103-.164-.209-.27-.209h-6.91zm26.663 18.673c0 .105.108.209.215.209h8.204c.109 0 .217.105.217.21v5.857c0 .106-.108.21-.217.21h-15.921c-.109 0-.217-.104-.217-.21V8.817c0-.104.108-.209.217-.209h7.232c.108 0 .217.105.217.21v19.457h.053zM50.343 16.245c-.27.158-.54.419-.756.68-2.104 1.83-3.183 2.562-4.479 3.505-.378-1.57-.81-3.19-1.08-4.812 1.134-2.355 1.565-5.022.378-6.958-.485-.837-2.321-.94-2.753.053-.864 2.145-.97 4.289-.702 6.486-.594 1.15-1.294 2.144-1.888 2.824-.648.733-1.836 2.092-2.861 1.307-1.996-1.568-2.428-5.177-2.805-7.426-.217-1.256-2.755-1.204-2.916.052-.43 2.668-.594 8.683-4.047 9.414v-.155c-.432-2.093-.594-4.551-1.458-6.54-.378-.888-2.213-1.098-2.7-.155-1.51 2.77-2.157 5.91-2.86 9.047-.27-.941-.485-1.882-.756-2.824-.647-2.248-1.348-5.283-3.237-6.904-.81-.732-2.16-.68-2.7.314a34.356 34.356 0 0 0-2.481 6.225c-.81-3.035-2.106-5.912-4.319-8.16-.702-.733-2.266-.68-2.698.365C.419 19.332-.175 26.708.04 33.923c.055 1.465 3.023 1.361 2.968-.103-.215-6.12.217-12.344 2.16-18.202C8.192 20.272 8.353 26.6 8.786 31.885c.107 1.464 3.077 1.359 2.968-.106-.27-4.654.864-10.042 2.753-14.593.7 1.57 1.133 3.348 1.564 4.812.702 2.355 1.188 4.917 2.268 7.114.485.994 2.537 1.046 2.86-.104.917-2.93 1.296-6.173 2.16-9.258.108.732.215 1.411.376 2.092.54 2.615.92 5.335 1.836 7.845.486 1.307 3.4.785 2.86-.68-.647-1.778-1.024-3.661-1.402-5.491 3.076-.315 4.534-2.51 5.342-5.127.54 1.047 1.296 1.989 2.268 2.668 1.888 1.204 4.156.732 5.828-.575.432-.367.917-.785 1.35-1.308.27 1.098.54 2.196.756 3.296-.378.313-.757.628-1.187.993-3.023 2.564-9.446 7.585-8.15 12.188.701 2.352 3.831 3.4 6.044 3.347 2.968-.053 4.857-3.088 5.775-5.44 1.187-2.929 1.242-5.963.918-9.05-.055-.47-.108-.94-.216-1.41.163-.106.323-.263.485-.419 3.562-2.877 3.023-1.936 6.423-4.97 1.08-1.045-1.402-2.04-2.321-1.464h-.001zm-7.287 12.71c-.216 2.511-1.188 5.753-3.292 7.427-1.943 1.465-4.156-.575-3.777-2.562.43-2.04 2.32-3.924 3.725-5.388a44.436 44.436 0 0 1 3.237-3.086c.163 1.203.216 2.406.108 3.61h-.001z"
            />
          </g>
        </svg>
      </a>
    <p class="myCanalFooter__description">
      Vous êtes abonné ?<br />
      Tous les programmes de votre abonnement<br />
      sont sur myCANAL sur PC/Mac, smartphones<br />
      et tablettes.
    </p>
    <nav class="myCanalFooter__navigation">
      <ul>
        <li><a href="https://static.canal-plus.net/gitlab/infoslegales/production/cookies.html" target="_blank" rel="noopener noreferrer">Cookie</a></li>
        <li><a href="https://www.canalplus.com/mentions-legales/" target="_blank" rel="noopener noreferrer">Mentions légales</a></li>
        <li><a href="https://static.canal-plus.net/gitlab/infoslegales/production/cgu.html" target="_blank" rel="noopener noreferrer">CGU</a></li>
        <li><a href="https://www.vousmeritezcanalplus.com/metiers.html?" target="_blank" rel="noopener noreferrer">Offres d'emploi</a></li>
      </ul>
      <ul>
        <li><a href="https://static.canal-plus.net/gitlab/infoslegales/production/donnees-personnelles.html" target="_blank" rel="noopener noreferrer">Données personnelles</a></li>
        <li><a href="https://www.canalplus.com/articles/" target="_blank" rel="noopener noreferrer">Actualités</a></li>
        <li><a href="https://www.canalplus.com/tag/" target="_blank" rel="noopener noreferrer">Tags</a></li>
      </ul>
    </nav>
    <div class="myCanalFooter__socials">
      <p>Restez connectés</p>
      <ul class="myCanalFooter__socialsLinks">
        <li>
          <a href="https://www.facebook.com/mycanal" target="_blank" rel="noopener noreferrer">
            <img src="data:image/svg+xml,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 200 200' style='enable-background:new 0 0 200 200;' xml:space='preserve'%3E %3Cstyle type='text/css'%3E .st0%7Bfill:%23FFFFFF;%7D %3C/style%3E %3Cpath class='st0' d='M119.1,54.2c0-3.9,1-8.9,2-9.9c1-2,4.9-3.9,8.9-3.9h21.7l2-36.5l-4.9-1c-3,0-13.8-1-26.6-1 c-13.8,0-24.7,4.9-32.6,12.8c-8.9,8.9-9.9,21.7-9.9,36.5V70H50v38.5h29.6v89.8h39.5v-89.8h27.6l5.9-38.5h-33.5V54.2z'/%3E %3C/svg%3E" alt="facebook">
          </a>
        </li>
        <li>
          <a href="https://twitter.com/myCANAL" target="_blank" rel="noopener noreferrer">
            <img src="data:image/svg+xml,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 200 200' style='enable-background:new 0 0 200 200;' xml:space='preserve'%3E %3Cstyle type='text/css'%3E .st0%7Bfill:%23FFFFFF;%7D %3C/style%3E %3Cpath class='st0' d='M198.9,38.1c-7.5,3.2-15,5.4-23.6,6.4c8.6-5.4,15-12.9,18.2-22.5c-7.5,4.3-16.1,8.6-25.7,9.7 c-7.5-7.5-18.2-12.9-30-12.9c-22.5,0-40.8,18.2-40.8,40.8c0,3.2,0,6.4,1.1,9.7C63.7,67.1,34.7,51,14.3,26.3C11.1,32.7,9,39.2,9,46.7 C9,60.6,16.5,73.5,27.2,81c-6.4,0-12.9-2.1-18.2-5.4c0,19.3,13.9,36.5,32.2,39.7c-3.2,1.1-7.5,1.1-10.7,1.1c-2.1,0-5.4,0-7.5-1.1 c5.4,16.1,20.4,27.9,37.5,27.9C46.5,154,29.4,160.4,10,160.4c-3.2,0-6.4,0-9.7-1.1c18.2,13.9,39.7,20.4,62.2,20.4 c75.1,0,115.9-62.2,115.9-115.9v-5.4C186,53.1,193.5,45.6,198.9,38.1z'/%3E %3C/svg%3E" alt="twitter">
          </a>
        </li>
        <li>
          <a href="https://www.dailymotion.com/CANALPLUS" target="_blank" rel="noopener noreferrer">
            <img src="data:image/svg+xml,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 200 200' style='enable-background:new 0 0 200 200;' xml:space='preserve'%3E %3Cstyle type='text/css'%3E .st0%7Bfill:%23FFFFFF;%7D %3C/style%3E %3Cpath class='st0' d='M176.6,82.9v115h-41.5v-15.5c-12.4,12.4-25.9,16.6-43.5,16.6s-33.2-5.2-45.6-16.6c-16.6-14.5-25.9-33.2-25.9-56 c0-20.7,8.3-38.3,22.8-52.8c13.5-12.4,30.1-19.7,48.7-19.7c17.6,0,32.1,6.2,42.5,17.6V9.3l41.5-8.3v81.9L176.6,82.9L176.6,82.9z M99.9,90.2c-20.7,0-36.3,16.6-36.3,35.2c0,19.7,15.5,35.2,37.3,35.2c18.7,0,34.2-14.5,34.2-34.2S119.6,90.2,99.9,90.2L99.9,90.2z' /%3E %3C/svg%3E" alt="dailymotion">
          </a>
        </li>
        <li>
          <a href="https://www.youtube.com/user/canalplusfrance" target="_blank" rel="noopener noreferrer">
            <img src="data:image/svg+xml,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 200 200' style='enable-background:new 0 0 200 200;' xml:space='preserve'%3E %3Cstyle type='text/css'%3E .st0%7Bfill:%23FFFFFF;%7D %3C/style%3E %3Cpath class='st0' d='M124.1,161.9v-23.1c0-5.4-1.4-6.8-4.1-6.8c-1.4,0-2.7,1.4-5.4,2.7v34c1.4,1.4,2.7,2.7,5.4,2.7 C122.7,168.7,124.1,166,124.1,161.9z M151.3,142.9h9.5v-5.4c0-5.4-1.4-8.2-5.4-8.2c-2.7,0-5.4,2.7-5.4,8.2L151.3,142.9L151.3,142.9z M65.6,103.4v10.9H53.3v62.6H42.4v-62.6H30.2v-10.9H65.6L65.6,103.4z M95.5,122.4v54.4H86v-5.4c-4.1,4.1-8.2,6.8-10.9,6.8 c-2.7,0-5.4-1.4-6.8-4.1c0-1.4-1.4-4.1-1.4-8.2v-43.5h9.5v44.9c0,1.4,1.4,2.7,2.7,2.7s4.1-1.4,6.8-4.1v-42.2L95.5,122.4L95.5,122.4z M133.6,138.8v21.8c0,5.4,0,8.2-1.4,10.9c-1.4,4.1-4.1,6.8-8.2,6.8s-6.8-2.7-9.5-6.8v5.4H105v-73.5h9.5v24.5 c2.7-4.1,6.8-5.4,9.5-5.4c4.1,0,6.8,2.7,8.2,6.8C133.6,130.6,133.6,133.3,133.6,138.8z M170.3,157.8v8.2c0,2.7-1.4,4.1-2.7,5.4 c-2.7,4.1-6.8,5.4-12.2,5.4c-5.4,0-9.5-1.4-12.2-5.4c-2.7-2.7-2.7-6.8-2.7-12.2v-19c0-5.4,1.4-9.5,2.7-12.2 c2.7-4.1,6.8-5.4,12.2-5.4c5.4,0,9.5,1.4,12.2,5.4c2.7,2.7,2.7,6.8,2.7,12.2V151h-20.4v9.5c0,5.4,1.4,8.2,5.4,8.2 c2.7,0,4.1-1.4,4.1-4.1v-1.4v-5.4L170.3,157.8L170.3,157.8z M103.7,35.4v23.1c0,5.4-1.4,8.2-5.4,8.2c-2.7,0-5.4-2.7-5.4-8.2V35.4 c0-5.4,1.4-8.2,5.4-8.2C102.3,27.2,103.7,29.9,103.7,35.4z M182.6,141.5c0-17.7-1.4-29.9-2.7-39.5c-1.4-4.1-2.7-8.2-6.8-10.9 c-2.7-2.7-6.8-4.1-10.9-5.4c-13.6-1.4-34-2.7-61.2-2.7s-47.6,1.4-61.2,2.7c-4.1,0-8.2,2.7-10.9,5.4C26.1,93.9,23.4,98,22,102 c-1.4,8.2-2.7,21.8-2.7,39.5s1.4,29.9,2.7,39.5c1.4,4.1,2.7,8.2,6.8,10.9c2.7,2.7,6.8,4.1,10.9,5.4c13.6,1.4,34,2.7,61.2,2.7 s47.6-1.4,61.2-2.7c4.1,0,8.2-2.7,10.9-5.4c2.7-2.7,5.4-6.8,6.8-10.9C182.6,172.8,182.6,159.2,182.6,141.5z M69.7,44.9L83.3,0H72.4 l-8.2,28.6L56.1,0H43.8l4.1,10.9c0,0,1.4,4.1,4.1,10.9c4.1,10.9,5.4,17.7,6.8,23.1v29.9h10.9L69.7,44.9L69.7,44.9z M113.2,57.1v-19 c0-5.4-1.4-9.5-2.7-13.6c-2.7-4.1-6.8-5.4-12.2-5.4s-9.5,1.4-12.2,5.4c-2.7,2.7-2.7,6.8-2.7,13.6v19c0,5.4,1.4,9.5,2.7,13.6 c2.7,4.1,6.8,5.4,12.2,5.4s8.2-1.4,12.2-5.4C111.8,66.7,113.2,62.6,113.2,57.1z M140.4,74.8h9.5V19h-9.5v42.2 c-2.7,2.7-4.1,4.1-6.8,4.1c-1.4,0-2.7-1.4-2.7-2.7V17.7h-9.5v43.5c0,4.1,0,6.8,1.4,8.2c1.4,2.7,2.7,4.1,6.8,4.1 c4.1,0,6.8-2.7,10.9-6.8L140.4,74.8L140.4,74.8z'/%3E %3C/svg%3E" alt="youtube">
          </a>
        </li>
      </ul>
    </div>
    <p class="myCanalFooter__credits">© CANAL 2019</p>
  </footer>
</template>

<script>
export default {
  name: 'MyCanalFooter',
};
</script>

<style lang="scss" scoped>
.myCanalFooter {
  background-color: #212429;
  color: #ffffff;
  font-family: 'Open Sans', sans-serif;
  padding: 37px 20px;
  position: relative;
  z-index: 0;

  @include media(">=l") {
    display: flex;
    flex-wrap: wrap;
    padding: 25px 20px;
  }

  &__logo,
  &__description {
    display: none;

    @include media(">=l") {
      display: block;
    }
  }

  &__logo {
    margin-bottom: 18px;

    svg {
      max-width: 196px;
    }
  }

  &__description {
    opacity: 0.5;
    line-height: 1.47;

    @include media(">=l") {
      width: 27%;
    }
  }

  &__description,
  &__navigation ul li,
  &__socials p {
    font-size: 15px;
  }

  &__navigation {
    margin-bottom: 50px;

    @include media(">=l") {
      width: 45.7%;
    }

    ul {
      width: 50%;

      li {
        line-height: 1.73;

        a {
          text-decoration: none;

          @media (hover: hover) {
            &:hover {
              opacity: 0.5;
            }
          }
        }
      }
    }
  }

  &__navigation,
  &__socials ul {
    display: flex;
  }

  &__socials {
    margin-bottom: 10px;

    p {
      font-weight: 600;
      margin-bottom: 12px;
    }

    ul li:not(:last-child) {
      margin-right: 10px;
    }

    ul li a {
      background-color: #3b3b3b;
      border-radius: 50%;
      display: block;
      height: 30px;
      position: relative;
      width: 30px;

      img {
        height: 60%;
        left: 50%;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
        width: auto;
      }
    }

    @media (hover: hover) {
      ul li {
        &:nth-child(1) a:hover {
          background-color: #3b5897;
        }
        &:nth-child(2) a:hover {
          background-color: #00aceb;
        }
        &:nth-child(3) a:hover {
          background-color: #0066db;
        }
        &:nth-child(4) a:hover {
          background-color: #bd0000;
        }
      }
    }
  }

  &,
  &__logo,
  &__credits {
    width: 100%;
  }

  &__logo,
  &__credits {
    flex-shrink: 0;
  }

  &__credits {
    text-align: right;
  }
}
</style>
